import type { Chart } from 'chart.js';

const crosshairLineColor = 'rgba(148, 158, 172, 0.5)';

export type CrosshairChart = Chart<'line'> & { $crosshairX?: number | null };

export const crosshairPlugin = {
  id: 'crosshair',
  afterDraw(chart: CrosshairChart) {
    const crosshairX = chart.$crosshairX;
    if (crosshairX == null) {
      return;
    }

    const xScale = chart.scales.x;
    const yScale = chart.scales.y;
    if (!xScale || !yScale) {
      return;
    }

    const pixelX = xScale.getPixelForValue(crosshairX);
    const { left, right } = chart.chartArea;
    if (pixelX < left || pixelX > right) {
      return;
    }

    const ctx = chart.ctx;
    ctx.save();
    ctx.beginPath();
    ctx.setLineDash([4, 4]);
    ctx.strokeStyle = crosshairLineColor;
    ctx.lineWidth = 1;
    ctx.moveTo(pixelX, chart.chartArea.top);
    ctx.lineTo(pixelX, chart.chartArea.bottom);
    ctx.stroke();
    ctx.restore();
  },
};

export function setChartCrosshairX(chart: CrosshairChart, x: number | null): boolean {
  if (chart.$crosshairX === x) {
    return false;
  }
  chart.$crosshairX = x;
  return true;
}
